import { render, staticRenderFns } from "./MainWidget.vue?vue&type=template&id=af41906c"
import script from "./MainWidget.vue?vue&type=script&lang=js"
export * from "./MainWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports